// 없는 주소로 들어왔을 때 보여 주는 안내 페이지 (시안에는 없어 공통 색·글꼴로 간단히 만듦)
export default function NotFound() {
  return (
    <main className="nf">
      <div className="ib-wrap nf__inner">
        <div className="nf__eyebrow">404 / PAGE NOT FOUND</div>
        <h1>
          페이지를 찾을 수 없습니다<span>.</span>
        </h1>
        <p>주소가 바뀌었거나 없는 페이지입니다. 아래 메뉴에서 원하시는 내용을 찾아 주세요.</p>
        <div className="nf__links">
          <a href="/">HOME</a>
          <a href="/business">BUSINESS</a>
          <a href="/portfolio">PORTFOLIO</a>
          <a href="/contact">CONTACT</a>
        </div>
      </div>
    </main>
  );
}
